import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import PromptPicker from '../promptPicker';
import { FaCaretUp, FaCaretDown, FaPlus, FaMinus } from 'react-icons/fa';

class CustomMessages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            filterBy: {},
            sortBy: 'DisplayName',
            sortOrder: 1,
            loading: false,
            type: "special",
            "editMessage": false
        };
    }

    moveItem = (result) => {
        console.log(result)
        // Logic to reorder prompts based on drag result
    }
    removeItem = (index) => {
        // ... logic to remove an item
    }
    addItem = () => {
        // ... logic to add an item
    }

    handleTempMessageValueChange = (event, optionCount) => {
        const { value } = event.target;
        const updatedTempMessage = { ...this.state.tempMessage };
        updatedTempMessage.menu[optionCount].transferTo = this.validateAndFormatPhoneNumber(value);
        this.setState({ tempMessage: updatedTempMessage });
    }
    handleTempMessageValueChangeMain = (event, optionCount) => {
        const { value } = event.target;
        const updatedTempMessage = { ...this.state.tempMessage };
        updatedTempMessage.transferTo = this.validateAndFormatPhoneNumber(value);
        this.setState({ tempMessage: updatedTempMessage });
    }

    //Main Edit Functions
    mainToggle = (param) => (e) => {
        //update param to the oppiste of what it is in temp message
        var tempMessage = this.state.tempMessage
        tempMessage[param] = !tempMessage[param]
        this.setState({ tempMessage: tempMessage })

    }
    mainHandleNameEdit = (e) => {
        var tempMessage = this.state.tempMessage
        tempMessage.name = e.target.value
        this.setState({ tempMessage: tempMessage })
    }
    mainHandlecustomFieldEdit = (e) => {
        //Pull the feild from the input
        var feild = e.target.getAttribute('customField')
        var tempMessage = this.state.tempMessage
        tempMessage[feild] = e.target.value
        this.setState({ tempMessage: tempMessage })
    }


    //Menu Edit Functions


    //Other
    cancel = () => {
        this.setState({ editMessage: false, tempMessage: false, loading: false, error: '' })
    }
    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }




    confirmEdit = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempMessage = this.state.tempMessage
        tempMessage.creationDate = new Date().toJSON()
        this.props.ws.send(JSON.stringify({ route: 'updateCustomMessages', data: tempMessage }))
        //update state to not be editing
        this.setState({ editMessage: false, loading: false, tempMessage: null })
    }
    deleteMessage = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempMessage = this.state.tempMessage
        this.props.ws.send(JSON.stringify({ route: 'deleteCustomMessages', data: tempMessage }))
        //update state to not be editing
        this.setState({ editMessage: false, loading: false, tempMessage: null })
    }
    addMessage = () => {
        // Add your logic here to handle confirming the edit
        //Create empty tempMessage
        var tempMessage = {
            "name": "",
            "prompt": [
                "1",
                "2",
                "3"
            ],
            "start": new Date().toJSON(),
            "end": new Date().toJSON(),
            "id": uuidv4(),
            "product": "",
            "barge": true,
            "active": false,
            "menu": []
        }
        this.setState({ editMessage: true, loading: false, tempMessage: tempMessage, error: '' })
    }
    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }
    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }
    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    toggleKey = (key) => {
        //add a menu iterm to temp message with the key
        var tempMessage = this.state.tempMessage
        //Check if the key is already in the menu
        var keyExists = false
        for (var item of tempMessage.menu) {
            if (item.menuKey === key) {
                keyExists = true
            }
        }
        //If it does
        if (keyExists) {
            tempMessage.menu = tempMessage.menu.filter(function (item) {
                return item.menuKey !== key
            })
        } else {
            tempMessage.menu.push({
                "active": true,
                "prompt": "",
                "actionAfterPlaying": "",
                "transferTo": "",
                "menuKey": key,
            })
        }
        //Reorder meny based on key, put * and pound at the end 
        tempMessage.menu.sort(function (a, b) {
            if (a.menuKey === "*") {
                return 1
            } else if (a.menuKey === "#") {
                return 1
            } else if (b.menuKey === "*") {
                return -1
            } else if (b.menuKey === "#") {
                return -1
            } else {
                return a.menuKey > b.menuKey ? 1 : -1
            }
        })
        console.log(tempMessage.menu);
        this.setState({ tempMessage: tempMessage })
    };

    renderKeypadButton = (key) => {
        //if tempMessage.menu has a menu item with the key, set isSelected to true
        var isSelected = false
        for (var item of this.state.tempMessage.menu) {
            console.log(item.menuKey, key)
            if (item.menuKey === key) {
                console.log("true")
                isSelected = true
            }
        }
        const buttonStyle = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '40px',
            width: '40px',
            borderRadius: '50%',
            backgroundColor: isSelected ? '#339977' : '#f2f2f2',
            color: isSelected ? 'white' : 'black',
            cursor: 'pointer',
            userSelect: 'none'
        };
        const hoverStyle = {
            backgroundColor: isSelected ? '#3ba481' : '#e0e0e0'
        };

        return (
            <div
                key={key}
                style={buttonStyle}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor}
                onClick={() => this.toggleKey(key)}
            >
                {key}
            </div>
        );
    };
    checkType = (e) => {
        this.setState({ type: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }
    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }
    editMessage = (ID) => (e) => {
        var message = JSON.parse(JSON.stringify(this.props.data.CustomMessages.data.find(function (element) {
            return element.id === ID;
        })))
        var newState = { editMessage: true, loading: false, tempMessage: message, error: '' }
        this.setState(newState)
    }
    mainPromptChange = (e, value) => {
        //update the prompt of the tempMessage

        var tempMessage = this.state.tempMessage
        tempMessage.prompt = value
        this.setState({ tempMessage: tempMessage })
    }
    menuPromptChange = (e, value) => {
        var index = e.target.getAttribute('itemindex')
        console.log("Index Passed: " + index)
        var tempMessage = this.state.tempMessage;
        tempMessage.menu[index].prompt = value;
        this.setState({ tempMessage: tempMessage });
    }
    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })

    }
    toggleMenuCheckbox(optionIndex) {
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.menu[optionIndex].active = !tempMessage.menu[optionIndex].active;
        this.setState({ tempMessage });
    }
    handleSelectChange(event) {
        let optionIndex = event.target.getAttribute('itemindex');
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.menu[optionIndex].actionAfterPlaying = event.target.value;
        this.setState({ tempMessage });
    }
    handleSelectChangeMain(event) {
        let tempMessage = { ...this.state.tempMessage };
        tempMessage.actionAfterPlaying = event.target.value;
        this.setState({ tempMessage });
    }
    // Function to validate and format phone number
    validateAndFormatPhoneNumber = (input) => {
        const phoneNumber = input.replace(/\D/g, ''); // Remove non-numeric characters
        if (phoneNumber.length === 10) {
            const formattedPhoneNumber = `+1${phoneNumber}`;
            return formattedPhoneNumber;
        }
        return input; // Return the original input if it doesn't match the format
    }


    // {this.state.tempMessage.prompt.map((prompt, index) => (
    //     <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    //         <div> {/* Plus and Minus icons on the left */}
    //             {index === promptCount - 1 ? (
    //                 <div style={{ background: '#2a6aa9', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', marginRight: '10px' }}>
    //                     <FaPlus
    //                         onClick={() => {/* Add your logic for adding an item */ }}
    //                         style={{ cursor: 'pointer', color: 'white', fontSize: '16px' }}
    //                     />
    //                 </div>
    //             ) : (
    //                 <div style={{ background: '#2a6aa9', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', marginRight: '10px' }}>
    //                     <FaMinus
    //                         onClick={() => this.removeItem(index)}
    //                         style={{ cursor: 'pointer', color: 'white', fontSize: '16px' }}
    //                     />
    //                 </div>
    //             )}
    //         </div>
    //         <PromptPicker
    //             itemindex={index}
    //             prompts={Prompts}
    //             currentPrompt={prompt}
    //             selectionChange={this.mainPromptChange}
    //             ws={this.props.ws}
    //         />
    //         <div style={{ marginLeft: 'auto' }}> {/* Arrows on the right */}
    //             {index !== 0 && (
    //                 <FaCaretUp
    //                     onClick={() => this.moveItem(index, 'up')}
    //                     style={{ cursor: 'pointer', color: '#2a6aa9', fontSize: '40px' }}
    //                 />
    //             )}
    //             {index !== promptCount - 1 && (
    //                 <FaCaretDown
    //                     onClick={() => this.moveItem(index, 'down')}
    //                     style={{ cursor: 'pointer', color: '#2a6aa9', fontSize: '40px' }}
    //                 />
    //             )}
    //         </div>
    //     </div>
    // ))}
    render() {
        if (this.props.active) {
            // if (this.state.type === "" || this.state.type === undefined) {
            //     this.setState({ type: "user" })
            // }


            var messageList = []
            var CustomMessages = JSON.parse(JSON.stringify(this.props.data.CustomMessages.data));
            var settings = JSON.parse(JSON.stringify(this.props.data.CustomMessages.settings));
            var Prompts = JSON.parse(JSON.stringify(this.props.data.Prompts));
            const keys = settings.menuOptions
            const keypadStyle = {
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: '5px',
                padding: '5px'
            };


            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                CustomMessages = this.filterFunc(CustomMessages, this.state.filterBy)
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                CustomMessages.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            for (var message of CustomMessages) {


                messageList.push(
                    <tr className="dataRow" onClick={this.editMessage(message.id)} key={prompt.id}>
                        <td style={{ flex: '1 0 180px', textAlign: 'left' }}>{message.name}</td>
                        <td style={{ minWidth: '100px', textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                            {message.active ?
                                <div style={{
                                    backgroundColor: '#2A6AA9',
                                    color: 'white',
                                    borderRadius: '50%',
                                    height: '20px',
                                    width: '20px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <svg width="10" height="8" viewBox="0 0 10 8">
                                        <path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
                                    </svg>
                                </div>
                                : null
                            }
                        </td>
                        <td style={{ flex: '0 0 250px', textAlign: 'left' }}>
                            {new Date(message.start).toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                            })}
                        </td>
                        <td style={{ flex: '0 0 250px', textAlign: 'left' }}>
                            {new Date(message.end).toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true
                            })}
                        </td>
                    </tr>
                );

            }
            var editMessage = ""
            if (this.state.editMessage) {

                var menuOptions = []

                const promptCount = this.state.tempMessage.prompt.length;
                var optionTotal = this.state.tempMessage.menu.length
                var actionAfterPlaying = []
                for (var item of Object.keys(settings.actionAfterPlaying)) {
                    if (item == "Custom") {
                        //Combine the array of custom with actionAfterPlaying
                        for (var customItem of settings.actionAfterPlaying.Custom) {
                            actionAfterPlaying.push(<option value={customItem.toLowerCase()}>{customItem}</option>)
                        }
                    } else {
                        if (settings.actionAfterPlaying[item]) {
                            actionAfterPlaying.push(<option value={item.toLowerCase()}>{item}</option>)
                        }
                    }
                }
                var customFields = []
                for (var item of settings.customFields) {
                    customFields.push(<div className="snazzyInputBox">
                        <input className="textInput" customField={item} type="text" required value={this.state.tempMessage[item] || ""} onChange={this.mainHandlecustomFieldEdit} ></input>
                        <span className="inputBar"></span>
                        <label className="textLabel">{item}</label>
                    </div>)
                }
                for (var option of this.state.tempMessage.menu) {
                    //Set option count to position in array
                    var optionCount = this.state.tempMessage.menu.indexOf(option)
                    menuOptions.push(
                        <div style={{ backgroundColor: '#f2f2f2', padding: '3px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: "center", marginBottom: "8px" }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '30px',
                                width: '30px',
                                borderRadius: '50%',
                                backgroundColor: '#339977',
                                color: 'white',
                                cursor: 'pointer',
                                userSelect: 'none',
                                marginRight: '1px',
                                marginLeft: '1px',
                                fontSize: '20px' // Adjust font size as needed
                            }}>
                                {option.menuKey}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>

                                {this.state.tempMessage.menu[optionCount].active && (
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '5px', borderRadius: '8px' }}>
                                        <PromptPicker prompts={Prompts} itemindex={optionCount} currentPrompt={this.state.tempMessage.menu[optionCount].prompt} selectionChange={this.menuPromptChange} ws={this.props.ws} />


                                        <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                            <label style={{ marginRight: "10px", fontSize: "12" }}>Action After Playing</label>
                                            <select
                                                style={{
                                                    width: '150px',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #2A6AA9',
                                                    marginBottom: '10px',
                                                    backgroundColor: '#ffffff',
                                                    marginRight: '10px'
                                                }}
                                                itemindex={optionCount}
                                                value={this.state.tempMessage.menu[optionCount].actionAfterPlaying}
                                                onChange={(event) => { this.handleSelectChange(event) }}
                                            >
                                                {actionAfterPlaying}
                                            </select>
                                        </div>
                                        {this.state.tempMessage.menu[optionCount].actionAfterPlaying === "transfer" && (
                                            <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                                <label style={{ marginRight: "10px", fontSize: "12" }}>Transfer To</label>
                                                {/*Text Box to enter phone number*/}
                                                <input

                                                    style={{
                                                        width: '150px',
                                                        padding: '8px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #2A6AA9',
                                                        marginBottom: '10px',
                                                        backgroundColor: '#ffffff',
                                                        marginRight: '10px'
                                                    }}
                                                    type="text"
                                                    value={this.state.tempMessage.menu[optionCount].transferTo}
                                                    onChange={(event) => { this.handleTempMessageValueChange(event, optionCount) }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                }
                editMessage = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{ overflow: "" }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            {
                                !this.state.tempMessage.permanent ? (
                                    <div className="snazzyInputBox">
                                        <input className="textInput" type="text" required value={this.state.tempMessage.name} onChange={this.mainHandleNameEdit} ></input>
                                        <span className="inputBar"></span>
                                        <label className="textLabel">Name</label>
                                    </div>
                                ) : (
                                    <h2>{this.state.tempMessage.name}</h2>
                                )
                            }
                            {customFields}
                            {/* Dropdown using promptNames array */}
                            <div style={{ border: '1px solid #d3d3d3', borderRadius: '8px', padding: '10px', backgroundColor: '#f0f0f0' }}> {/* Soft gray border and fill */}
                                <PromptPicker prompts={Prompts} currentPrompt={this.state.tempMessage.prompt} selectionChange={this.mainPromptChange} ws={this.props.ws} />

                            </div>


                            <div style={{ display: 'inline-block', paddingTop: '8px' }}>
                                <div>Start</div>
                                <Flatpickr
                                    style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                    options={{ dateFormat: "Y-m-d h:i K" }}
                                    data-enable-time
                                    value={this.state.tempMessage.start}
                                    onChange={date => {
                                        date[0] ? this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                start: date[0]
                                            }
                                        })) : this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                start: undefined
                                            }
                                        }))
                                    }}
                                />
                            </div>
                            <div style={{ display: 'inline-block' }}>
                                <div>End</div>
                                <Flatpickr
                                    style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }}
                                    options={{ dateFormat: "Y-m-d h:i K" }}
                                    data-enable-time
                                    value={this.state.tempMessage.end}
                                    onChange={date => {
                                        date[0] ? this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                end: date[0]
                                            }
                                        })) : this.setState(prevState => ({
                                            tempMessage: {
                                                ...prevState.tempMessage,
                                                end: undefined
                                            }
                                        }))
                                    }}
                                />
                            </div>




                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
                                <div >
                                    <div>Active</div>
                                    <div className="activeBox" style={{ position: "static" }} onClick={this.mainToggle('active')}>
                                        <div className={this.state.tempMessage.active ? "enabled" : "disabled"} style={{ position: "static", "z-index": "1" }}></div>
                                    </div>
                                </div>
                                <div >
                                    <div>Allow Barge</div>
                                    <div className="activeBox" style={{ position: "static" }} onClick={this.mainToggle('barge')}>
                                        <div className={this.state.tempMessage.barge ? "enabled" : "disabled"} style={{ position: "static" }}></div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                <label style={{ marginRight: "10px", fontSize: "12" }}>Action After Playing</label>
                                <select
                                    style={{
                                        width: '150px',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        border: '1px solid #2A6AA9',
                                        marginBottom: '10px',
                                        backgroundColor: '#ffffff',
                                        marginRight: '10px'
                                    }}
                                    value={this.state.tempMessage.actionAfterPlaying}
                                    onChange={(event) => { this.handleSelectChangeMain(event) }}
                                >

                                    {actionAfterPlaying}
                                </select>
                            </div>
                            {this.state.tempMessage.actionAfterPlaying === "transfer" && (
                                <div style={{ alignItems: 'center', marginBottom: '10px' }}>
                                    <label style={{ marginRight: "10px", fontSize: "12" }}>Transfer To</label>
                                    {/*Text Box to enter phone number*/}
                                    <input

                                        style={{
                                            width: '150px',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            border: '1px solid #2A6AA9',
                                            marginBottom: '10px',
                                            backgroundColor: '#ffffff',
                                            marginRight: '10px'
                                        }}
                                        type="text"
                                        value={this.state.tempMessage.transferTo}
                                        onChange={(event) => { this.handleTempMessageValueChangeMain(event) }}
                                    />
                                </div>
                            )}

                            {settings.menu && (
                                <div style={keypadStyle}>
                                    {keys.map(this.renderKeypadButton)}
                                </div>)}
                            {settings.menu && menuOptions}

                            <div className="error" style={{ padding: '15px' }}>{this.state.error}</div>
                            {this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmEdit}>Confirm Message</div>}
                            {/*Delete Button with style to make it red*/}
                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}></div>
                            {!this.state.tempMessage.permanent && <div className="button" style={{ backgroundColor: "Red" }} onClick={this.deleteMessage}>Delete Message</div>}
                            <div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}></div>

                        </div>
                    </div >
                )
            }

            var addButton = ""
            addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a Domain" onClick={this.addMessage} />
            return (
                <div width="100%">

                    {settings.additive && addButton}

                    < div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '200px', marginRight: '10px', marginTop: '2px' }}>
                            <div className="filterBox" style={{
                                "width": "210px"
                            }}>
                                <h4>Filter By:</h4>
                                <div style={{ width: '150px' }}>
                                    <label>Name:</label>
                                    <input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ float: "right" }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ minWidth: '220px', cursor: 'pointer', textAlign: 'left' }} >Name {this.filterIcon("name")}</th>
                                        <th style={{ minWidth: '100px', cursor: 'pointer', textAlign: 'left' }} >Active {this.filterIcon("active")}</th>
                                        <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} >Start {this.filterIcon("start")}</th>
                                        <th style={{ minWidth: '250px', cursor: 'pointer', textAlign: 'left' }} >End {this.filterIcon("end")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messageList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editMessage}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        // eslint-disable-next-line
        return v.toString(16);
    });
};

const icon = "menuSpeech"
const roles = ["View"]
export { CustomMessages, icon, roles }

